function SectionAncor({ id }) {
	return <div id={id}></div>;
}

export default SectionAncor;
